/*
Trash Bins
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Trash Bins'
const id = 'vEPx65DLdaiOAJs6CU7U'

export default {
  name,
  id,
  filters,
  headers,
  form
}
